export const PEOPLE_DIRECTORY_ROUTE = `/people/`;

const LETTER_OR_MISC_REGEX = 'misc|[a-z]{1}';
const COUNTRY_REGEX = '[a-z]{0,2}';
const DIGITS_REGEX = '\\d+';
const SLUG_REGEX = ':slug([a-zA-Z]+-[a-zA-Z]+)';
const SLUG_PAGE_REGEX = '-p:page([0-9]+)';
const CHUNK_PAGE_LEVEL_REGEX = '[1-2]{1}';

export const routes = {
  PEOPLE_DIRECTORY_ROUTE: PEOPLE_DIRECTORY_ROUTE,
  PAGES_BY_USERNAME: {
    // {PEOPLE_DIRECTORY_ROUTE}/a/
    LETTER_PAGE: `${PEOPLE_DIRECTORY_ROUTE}:letter(${LETTER_OR_MISC_REGEX})/`,

    // {PEOPLE_DIRECTORY_ROUTE}/pages/a/2/1/
    CHUNK_PAGE: `${PEOPLE_DIRECTORY_ROUTE}pages/:letter(${LETTER_OR_MISC_REGEX})/:pageLevel(${CHUNK_PAGE_LEVEL_REGEX})/:page(${DIGITS_REGEX})/`,

    // {PEOPLE_DIRECTORY_ROUTE}/bauer-michael/
    USER_BAG_PAGE: `${PEOPLE_DIRECTORY_ROUTE}${SLUG_REGEX}/`,

    // {PEOPLE_DIRECTORY_ROUTE}/bauer-michael-p3/
    USER_BAG_PAGE_PAGINATED: `${PEOPLE_DIRECTORY_ROUTE}${SLUG_REGEX}${SLUG_PAGE_REGEX}/`,
  },
  PAGES_BY_CITY: {
    // {PEOPLE_DIRECTORY_ROUTE}/cities/
    LISTING_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/`,

    // {PEOPLE_DIRECTORY_ROUTE}/cities/de/muenchen/
    CITY_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/`,

    // {PEOPLE_DIRECTORY_ROUTE}/cities/de/hamburg/a/
    LETTER_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/:letter(${LETTER_OR_MISC_REGEX})/`,

    // {PEOPLE_DIRECTORY_ROUTE}/cities/de/berlin/pages/a/1/1/
    CHUNK_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/pages/:letter(${LETTER_OR_MISC_REGEX})/:pageLevel(${CHUNK_PAGE_LEVEL_REGEX})/:page(${DIGITS_REGEX})/`,

    // {PEOPLE_DIRECTORY_ROUTE}/cities/de/berlin/albrecht-christian/
    USER_BAG_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/${SLUG_REGEX}/`,

    // {PEOPLE_DIRECTORY_ROUTE}/cities/de/berlin/albrecht-christian-p3/
    USER_BAG_PAGE_PAGINATED: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/${SLUG_REGEX}${SLUG_PAGE_REGEX}/`,
  },
};
